import styled from 'styled-components'
import { ButtonUnstyled } from '@sketch/components'

export const Wrapper = styled.span`
  display: block;
  line-height: 0;

  [role='img'] {
    width: 17px;
    height: 17px;
  }
`

export const Button = styled(ButtonUnstyled)`
  display: block;
  line-height: 1;
  color: currentColor;
`
